const LENDING_METADATA_CONTROL_PARAMS = new Set([
  "token",
  "olb_application",
  "cross_sell_application",
]);

function getApplicationMetadataFromUrl(): Record<string, string> | undefined {
  const searchParams = new URLSearchParams(window.location.search);

  for (const [key] of [...searchParams.entries()]) {
    if (LENDING_METADATA_CONTROL_PARAMS.has(key.toLowerCase())) {
      searchParams.delete(key);
    }
  }

  const metadata = Object.fromEntries(searchParams.entries());
  return Object.keys(metadata).length > 0 ? metadata : undefined;
}

export { getApplicationMetadataFromUrl };
